// Writings list — post-processes the /writings/ archive:
//
// 1. Injects a year divider before each entry whose data-year
//    differs from the previous entry's (Handlebars can't detect
//    a year change mid-iteration, so we do it here).
// 2. Swaps the total-count placeholder with the real number of
//    essays on the page.
// 3. Shows an empty-state panel when there are no essays yet.

export default function writingsList() {
    const stream = document.querySelector("[data-writings-stream]");
    if (!stream) return;

    const entries = stream.querySelectorAll(".gg-writings-page__entry");
    const totalEl = document.querySelector("[data-writings-total]");
    const countEl = document.querySelector("[data-writings-count]");
    const emptyEl = document.querySelector("[data-writings-empty]");

    // Empty state
    if (!entries.length) {
        if (emptyEl) emptyEl.removeAttribute("hidden");
        if (totalEl) totalEl.textContent = "0 essays";
        if (countEl) countEl.textContent = "Ongoing";
        return;
    }

    // Year dividers
    let lastYear = null;
    entries.forEach((entry) => {
        const year = entry.dataset.year;
        if (!year || year === lastYear) return;

        const divider = document.createElement("div");
        divider.className = "gg-writings-page__year";
        divider.innerHTML =
            `<span class="gg-writings-page__year-label">${year}</span>` +
            `<span class="gg-writings-page__year-rule"></span>`;
        stream.insertBefore(divider, entry);
        lastYear = year;
    });

    // Counts
    const total = entries.length;
    const plural = total === 1 ? "essay" : "essays";
    if (totalEl) totalEl.textContent = `${total} ${plural}`;
    if (countEl) countEl.textContent = `${total} of ${total} · ongoing`;
}
